import { EstensaColDef } from '../search-param.model';
import {
    BoolIconRendererIconType,
} from '../search-result/cell-renderers/bool-icon-renderer/bool-icon-renderer.component';

export function visitColumnDefs(translate, gridUtils): EstensaColDef[] {
    return [
        {
            colId: 'lockColId',
            headerName: '',
            tooltipField: '',
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px', left: '' },
            cellRenderer: 'lockUnlockRenderer',
            cellRendererParams: {
                lockedField: 'locked',
                userField: 'lockedUserFullName',
            },
        },
        {
            colId: 'ExamOutOfFlow',
            headerName: '',
            valueGetter: (e) => e.data,
            tooltipField: '',
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: true,
            comparator: (valueA, valueB) => {
                if (valueA.patient.isLocalPatient && valueB.patient.isLocalPatient) return 0;
                if (!valueA.patient.isLocalPatient && !valueB.patient.isLocalPatient) return 0;
                if (!valueA.patient.isLocalPatient && valueB.patient.isLocalPatient) return 1;

                return -1;
            },
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px', left: '30px' },
            cellRenderer: 'stateIconRenderer',
            cellRendererParams: {
                estensa: [
                    {
                        iconType: BoolIconRendererIconType.SeFont,
                        field: 'patient.isLocalPatient',
                        icon: 'icon_flusso_inverso',
                        tooltip: 'PatientDataNotAssociated',
                    },
                    {
                        iconType: BoolIconRendererIconType.AngularMaterial,
                        field: 'reportingWithoutTrace',
                        icon: 'image_not_supported',
                        tooltip: 'ExamWithoutTrace',
                    },
                    {
                        iconType: BoolIconRendererIconType.AngularMaterial,
                        field: 'fromIntegration',
                        icon: 'exit_to_app',
                        fontSize: '18px',
                        tooltip: 'ExternalIntegration',
                    },
                ],
            },
        },
        {
            colId: 'AssociatedVisit',
            headerName: '',
            valueGetter: (e) => e.data,
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px', left: '50px' },
            cellRenderer: 'associatedVisitsRenderer',
            cellRendererParams: (params) => {
                return params;
            },
        },
        {
            colId: '0',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) =>
                `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
            tooltipValueGetter: (e) =>
                `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
            width: 220,
            minWidth: 190,
            suppressSizeToFit: true,
            lockPosition: true,
            pinned: 'left',
            cellStyle: (e) => {
                if (e.data.patient.isCertificating === true) return { 'background-color': 'yellow' };
                if (e.data.patient.isCertificating === false && e.data.patient.isCertified === false)
                    return { 'background-color': 'red' };
                return null;
            },
        },
        {
            colId: '1',
            headerName: translate.instant('BirthDate'),
            headerTooltip: translate.instant('BirthDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'patient.birthDate',
            width: 180,
            minWidth: 130,
            valueFormatter: gridUtils.dateFormatter(['patient', 'birthDate']),
            comparator: gridUtils.dateComparator,
        },
        {
            headerName: translate.instant('ExamDate'),
            headerTooltip: translate.instant('ExamDate'),
            field: 'examinationDate',
            colId: '2',
            width: 150,
            minWidth: 120,
            sort: 'desc',
            valueFormatter: gridUtils.dateTimeFormatter('examinationDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
            tooltipValueGetter: (p) => p.valueFormatted,
        },
        {
            headerName: translate.instant('ReportDate'),
            headerTooltip: translate.instant('ReportDate'),
            field: 'reportDate',
            colId: '3',
            width: 150,
            minWidth: 120,
            valueFormatter: gridUtils.dateTimeFormatter('reportDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
        },
        // {
        //     headerName: translate.instant('ReferringPhysician'),
        //     headerTooltip: translate.instant('ReferringPhysician'),
        //     valueGetter: e => gridUtils.getFullName(e.data.referringPhysician),
        //     tooltipValueGetter: e => gridUtils.getFullName(e.data.referringPhysician),
        //     colId: '4',
        //     width: 220,
        //     minWidth: 190,
        //     suppressSizeToFit: false,
        //     hide: false,
        // },
        {
            headerName: translate.instant('ReferringPhysician'),
            headerTooltip: translate.instant('ReferringPhysician'),
            tooltipField: 'referringPhysicianFullNameList',
            field: 'referringPhysicianFullNameList',
            colId: '4',
            width: 220,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('ExamNumber'),
            headerTooltip: translate.instant('ExamNumber'),
            tooltipField: 'examNumber',
            field: 'examNumber',
            colId: '5',
            width: 190,
            minWidth: 160,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Exam'),
            headerTooltip: translate.instant('Exam'),
            tooltipField: 'exam.description',
            field: 'exam.description',
            colId: '6',
            width: 220,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('BusinessUnit'),
            headerTooltip: translate.instant('BusinessUnit'),
            tooltipField: 'businessUnit.description',
            field: 'businessUnit.description',
            colId: '7',
            width: 190,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Status'),
            headerTooltip: translate.instant('Status'),
            tooltipField: 'status',
            field: 'status',
            colId: '8',
            width: 80,
            minWidth: 70,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Severity'),
            headerTooltip: translate.instant('Severity'),
            tooltipField: 'severity.description',
            field: 'severity.description',
            cellStyle: (params) => ({
                color:
                    params.data.severity?.color?.toLocaleLowerCase() == 'white'
                        ? 'black'
                        : params.data.severity?.color?.toLocaleLowerCase(),
            }),
            colId: '9',
            width: 150,
            minWidth: 130,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Provenance'),
            headerTooltip: translate.instant('Provenance'),
            tooltipField: 'provenance.description',
            field: 'provenance.description',
            colId: '10',
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('GroupProvenance'),
            headerTooltip: translate.instant('GroupProvenance'),
            tooltipField: 'provenance.groupProvenance.description',
            field: 'provenance.groupProvenance.description',
            colId: '11',
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '12',
            headerName: translate.instant('PatientId'),
            headerTooltip: translate.instant('PatientId'),
            tooltipField: 'patient.patientId',
            field: 'patient.patientId',
            width: 190,
            minWidth: 150,
        },
        {
            headerName: translate.instant('OtherPatientId'),
            headerTooltip: translate.instant('OtherPatientId'),
            tooltipField: 'patient.otherPatientId',
            field: 'patient.otherPatientId',
            colId: '13',
            width: 190,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '14',
            headerName: translate.instant('ReportLocalId'),
            headerTooltip: translate.instant('ReportLocalId'),
            tooltipField: 'localId',
            field: 'localId',
            width: 100,
            minWidth: 80,
        },
    ];
}
